import { render } from "./buy-contract-draft.vue?vue&type=template&id=e842b58c"
import script from "./buy-contract-draft.vue?vue&type=script&lang=ts"
export * from "./buy-contract-draft.vue?vue&type=script&lang=ts"
script.render = render

export default script